<template>
  <div>
    <div style="margin-top: 80px;">
      <div style="width: 100%; max-width: 1920px; display: flex; flex-direction: column; justify-content: space-between; align-items: center;">
          <div :style="'width: '+($store.getters.getScreenWidth < 1400 ? '98%' : '70%')+'; display: flex; flex-direction: column; align-items: center;'">
              <span style="font-size: 28px; font-weight: 500;">
                Why choose Easy Tailor App?
              </span>
              <span style="margin-top: 40px; font-size: 18px; font-weight: 500;">
                Easy Tailor App is a cloud based solution provided to you as an service. 
                You get access to your business from any device, from any location without worrying about infrastructure management. 
                Multi-store business management, sales management, corporate invoicing, production management, customer portal for your clients, and more. 
                Features are endless and we frequently keep on adding new ones.
              </span>
          </div>          
      </div>
    </div>
  </div>
</template>

<script>
export default {
    computed: {
        getFeatureList() {
            return [
                'Handle multiple stores centrally.', 
                'Integrated e-payment &amp; e-commerce.',
                'Unlimited users, pay for the software not the users.',
                'Manage every aspect of your business centrally.'
            ]
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Home/Row4.vue